import { isMockApi } from '@/shared/env'

export function shouldUseKitchenApi(): boolean {
  return !isMockApi
}
